import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from '../../store/store'

import { filePeview, ErrorResult} from '../../shared/interfaces'

import { signFile  } from '../../services/authenticodeService'

interface authenticodeState {
  errorResult: ErrorResult | null ;
  inSignCall: boolean;
  isAllowed:boolean|null;
}

const initialState: authenticodeState = {
  errorResult: null,
  inSignCall: false,
  isAllowed:null
}

const authenticodeSlice = createSlice({
  name: 'authenticodeSlice',
  initialState,
  reducers: {
    clearError(state) {
      state.errorResult=null;
    },
    callService(state) {
      state.inSignCall=true;
    },
    authenticodeCallSuccess(state, action: PayloadAction<ErrorResult|null>) {
      state.errorResult = action.payload;
      state.inSignCall = false;
    },
    authenticodeCallFailed(state, action: PayloadAction<any>) {
      const res:ErrorResult = { No:-1, Message:action.payload.toString() };
      state.errorResult= res;
      state.inSignCall=false;
    }
  }
})

export const {
  clearError,
  callService,
  authenticodeCallSuccess,
  authenticodeCallFailed,
} = authenticodeSlice.actions

export default authenticodeSlice.reducer

export const sign = (file:filePeview): AppThunk => async dispatch => {
  let actionResult
  try {
    dispatch(callService());
    actionResult = await signFile(file)
  } catch (err) {
    dispatch(authenticodeCallFailed(err))
    return;
  }
  dispatch(authenticodeCallSuccess(actionResult))
}